export const LANDING_CONTACT_LEGAL_NAME = 'ИП ХУСИД МИХАИЛ АЛЕКСАНДРОВИЧ';
export const LANDING_CONTACT_COMPANY = LANDING_CONTACT_LEGAL_NAME;
export const LANDING_CONTACT_INN = '231225258140';
export const LANDING_CONTACT_OGRNIP = '323237500067162';
export const LANDING_CONTACT_EMAIL = 'michaelkhoussid@yandex.com';
export const LANDING_CONTACT_PHONE = '+79771717978';
export const LANDING_CONTACT_WEBSITE = 'https://chattenger.ru';
